import React, { useMemo, useEffect, useState, useCallback } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../redux/actions'
import { useHistory, useLocation } from 'react-router-dom'
import { FiArrowLeft, FiArrowUp } from 'react-icons/fi'
import title from '../../constants/Menu'
import { FaThumbsDown, FaThumbsUp } from 'react-icons/fa'
import Popup from '../../services/Popup'
import ShopListChangeStatusPopup from '../../services/ShopListChangeStatusPopup'
import '../../styles/containers/ListComprasVisualization.css'
import { imageBaseURL } from '../../services/defaultProps'
import useLanguage from '../../hooks/useLanguage'

const ListComprasVisualization = props => {
  const history = useHistory()
  const location = useLocation()

  const language = useLanguage()
  const [openPopup, setOpenPopup] = useState(false)
  const [openChangeStatusPopup, setOpenChangeStatusPopup] = useState(null)
  const [selectedTemplateStatusChange, setSelectedTemplateStatusChange] = useState(null)
  const [showGoTop, setShowGoTop] = useState(false)

  const nameCategory = useMemo(() => location.state && location.state.nameCategory, [])
  const category = useMemo(() => location.state && location.state.category, [])
  const items = useMemo(() => location.state && location.state.category === 'upload' ? props.user.shopListImage
    : props.user.shopListTemplate.filter((item) => category === item.category.toLowerCase()))

  const goTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, [])

  const emptyLinkPopup = () => {
    return (
      <Popup
        open={openPopup}
        close={() => setOpenPopup(false)}
        closeButton={false}
        textParagraph='Este produto não tem um link cadastrado.'
        textButton='Ok'
      />
    )
  }

  const changeItemStatus = (item, status) => {
    const popupStatus = (item.status === 'rejected' ? 'rejection' : item.status)

    if (popupStatus !== 'pending' && status !== popupStatus) return

    if (popupStatus === status) {
      if (popupStatus === 'bought') {
        setOpenChangeStatusPopup('removeFeedbackBought')
      } else {
        setOpenChangeStatusPopup('removeFeedbackRejection')
      }
    } else {
      setOpenChangeStatusPopup(status)
    }

    setSelectedTemplateStatusChange(item.id)
  }

  useEffect(() => {
    if (location.state && location.state.photo) {
      [...document.getElementsByClassName('shoplist-visualization-item')][location.state.photo]
        .scrollIntoView()
    } else if (location.state && location.state.fromSeeInShopList) {
      const itemsToShow = props.user.shopListTemplate.filter(item => item.category.toLowerCase() === category)

      const itemIndex = itemsToShow.findIndex(item => location.state.shopListItemId === item.id)

      const items = [...document.getElementsByClassName('shoplist-visualization-item')][itemIndex]
      items.scrollIntoView()
    }
  }, [])

  useEffect(() => {
    function onWindowScroll () {
      setShowGoTop(window.scrollY > 300)
    }

    window.addEventListener('scroll', onWindowScroll)

    return () => window.removeEventListener('scroll', onWindowScroll)
  }, [])

  if (!category) {
    history.push('/')
    return <div />
  }

  return (
    <div className='shoplist-visualization-container'>
      {emptyLinkPopup()}
      {openChangeStatusPopup && (
        <ShopListChangeStatusPopup
          popupType={openChangeStatusPopup}
          closePopup={() => setOpenChangeStatusPopup(null)}
          templateId={selectedTemplateStatusChange}
        />
      )}
      <div className='shoplist-visualization-title'>
        <FiArrowLeft onClick={() => location.state.fromSeeInShopList ? (
          history.push('/moodboard', location.state.stateToGoBack)
        ) : history.goBack()} size={24} color='var(--primary)' className='shoplist-visualization-goback' />
        <p>{category === 'upload' ? title.list[language] : nameCategory}</p>
      </div>
      <div className='shoplist-visualization-items'>
        {items.map(item => (
          <div key={item.id} className='shoplist-visualization-item'>
            <div className='shoplist-visualization-image'>
              <img src={category === 'upload' ? item.image : imageBaseURL + item.image} alt={item.image} />
            </div>
            {category !== 'upload' && (
              <div className='shoplist-visualization-template'>
                <p className='shoplist-visualization-name'>{item.name}<br />{item.brand}</p>
                <div className='shoplist-visualization-buttons'>
                  <button
                    disabled={item.status !== 'pending' && item.status !== 'bought'}
                    onClick={() => changeItemStatus(item, 'bought')}
                    className='shoplist-visualization-button item-bought'>
                    <FaThumbsUp size={14} style={{ marginRight: 6 }} color='white' /> Comprei
                  </button>
                  <button
                    disabled={item.status !== 'pending' && item.status !== 'rejected'}
                    onClick={() => changeItemStatus(item, 'rejection')}
                    className='shoplist-visualization-button notbought'>
                    <FaThumbsDown size={14} style={{ marginRight: 6 }} color='white' /> Não Comprei
                  </button>
                </div>
                {(item.link && item.status === 'pending') ? (
                  <a
                    href={item.link}
                    target='_blank' rel='noopener noreferrer'
                    disabled={item.status !== 'pending'}
                    className='shoplist-visualization-button buy'>Comprar
                  </a>
                ) : (
                  <button
                    onClick={() => setOpenPopup(true)}
                    disabled={item.status !== 'pending'}
                    className='shoplist-visualization-button buy'> Comprar
                  </button>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
      {showGoTop && <div className='go-top'>
        <FiArrowUp onClick={goTop} size={20} color='var(--primary)' />
      </div>}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(ListComprasVisualization)



// WEBPACK FOOTER //
// ./src/containers/ListCompras/ListComprasVisualization.js